import { useParams } from "react-router";

export const Redirect = () => {
 const { id } = useParams();

 return (
    window.location.replace(`${process.env.PUBLIC_URL}/dashboard/ld-looking-glass/${id}/details`)
 );
};